import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { createAppError } from 'utils/helpers';
import { AppContext, IAppContext } from 'appState/appContext';
import { getActualFileObject } from 'backend/additionalInformation';
import classNames from 'classnames';
import style from './DownloadButton.module.scss';

interface IDownloadBtn {
	filePath: string | null;
}

const DownloadBtn: React.FC<IDownloadBtn> = ({ filePath }) => {
	const { showLoader, hideLoader, addAppError } = useContext<IAppContext>(AppContext);
	const loaderClasses = classNames(style.loader, { [style.disabled]: !filePath });

	const downloadFile = async () => {
		if (filePath) {
			showLoader();
			try {
				const response = await getActualFileObject(filePath);
				const text = JSON.stringify(response.data);
				const a = document.createElement('a');
				let file = new Blob([text], { type: 'application/json' });
				const url = URL.createObjectURL(file);
				a.href = url;
				a.download = 'settings.json';
				a.click();
				URL.revokeObjectURL(url);
			} catch (err) {
				const error = err as Error;
				const appError = createAppError(error);
				addAppError(appError);
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<div className={style.container}>
			<div className={loaderClasses} onClick={downloadFile}>
				<div className={style.label}>
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#downloadArrow`} />
					</svg>
					<Text translationNameSpace="form" translationKey="downloadSettingsButton" asFragment={true} />
				</div>
			</div>
		</div>
	);
};

export default React.memo(DownloadBtn);
